export const gallerySectionWindowsCleaning =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        { "src": "/assets/imgs/services/00011WindowsCleaning/1.jpg", "rowSpan": 2, "colSpan": 1 },
        { "src": "/assets/imgs/services/00011WindowsCleaning/2.jpg", "rowSpan": 1, "colSpan": 2 },
        { "src": "/assets/imgs/services/00011WindowsCleaning/3.jpg", "rowSpan": 1, "colSpan": 1 },
    ]
}